module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "visible": "",
      "size": "lg",
      "hide-footer": true,
      "title": "Retour details"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('refund-form', {
    attrs: {
      "order-id": _vm.orderId,
      "refundId": _vm.refundId,
      "includeRefundShipmentCosts": _vm.includeRefundShipmentCosts
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b1ebcd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/refunds/RefundDetailModal.vue
// module id = 689
// module chunks = 1